import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiVisa, BasicApiResponseModel, Core2Config } from './../shared';
import { ResetSecurityPinConfirmRequestDtoModel, ResetSecurityPinInitRequestDtoModel } from "../../data-transfer-objects/reset-security-pin-dto.model";

@Injectable()
export class SecurityPinService {

  protected readonly endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'identity/pin/';

  constructor(protected readonly http: HttpClient) {}

  public resetInit(data: ResetSecurityPinInitRequestDtoModel, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    return this.http.post<BasicApiResponseModel<any>>(visa.api_domain_url + this.endpoint_path + 'reset_init', data, { headers: new HttpHeaders({ authorization: visa.jwt_secret, tenantCode: visa.tenantCode? visa.tenantCode : '', appId: visa.applet_code? visa.applet_code : 'none' }) });;
  }

  public resetConfirm(data: ResetSecurityPinConfirmRequestDtoModel, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    return this.http.post<BasicApiResponseModel<any>>(visa.api_domain_url + this.endpoint_path + 'reset_confirm', data, { headers: new HttpHeaders({ authorization: visa.jwt_secret, tenantCode: visa.tenantCode? visa.tenantCode : '', appId: visa.applet_code? visa.applet_code : 'none' }) });
  }
}